import React, { useState, useEffect } from 'react';
import { GrClose } from "react-icons/gr";
import { BiTrash } from "react-icons/bi";
import { BsPlusLg } from "react-icons/bs";
import PropTypes from 'prop-types';


function SpendingLimitModal({
  limit, 
  closeModal,
  handleChangeLimit,
  handleSaveLimit,
}) {
  const [showDetails, setShowDetails] = useState(false);
  const [editDetails, setEditDetails] = useState(true);
  const [addCard, setAddCard] = useState(true);

  const addCardFunc = () => {
    const addInput = document.getElementById("add-card-input");
  }
  
  return (
    <div className='popup-box'>
      <div className="overlay card-holder-details" onClick={() => closeModal()}></div>
      <div className="details-card">
        <GrClose className='close-btn' onClick={() => closeModal()} />
        <h3>Spending Limit</h3>
        <div className="data-point">
          <label className='profile-label'>Title: </label>
          <input 
            type="text" 
            className='gl-edit' 
            id="name"
            value={limit.name} 
            onChange={handleChangeLimit}
            />
        </div>
        <div className="data-point">
          <label className='profile-label'>Limit: </label>
          <input 
            type="number" 
            className='gl-edit' 
            id="displayLimit"
            value={limit.displayLimit} 
            onChange={handleChangeLimit}
          />
        </div>
        <div className="data-point">
          <label className="profile-label">Active:</label>
          {
            editDetails
            ?
            <input 
              type="Checkbox" 
              className='edit-details' 
              id="active"
              onChange={handleChangeLimit}
              value={limit.active} 
              checked={limit.active}
            />
            :
            <div className="profile-data">{limit.active ? "Yes" : "No"}</div>
          }
        </div>
        <button 
          className="btn btn-primary btn-full-width margin-top-small"
          onClick={() => handleSaveLimit(limit)}
        >
          Save
        </button>
      </div>
    </div>
  )
}

SpendingLimitModal.defaultProps = {

};

SpendingLimitModal.propTypes = {
  
};

export default SpendingLimitModal